import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ISession } from '../interfaces/i-session';
import { Repository } from '@clavisco/core';
import { StorageKeys } from '../enums/storage-keys';
import { AuthenticationService } from '../services/authentication.service';
import { AlertsService, CLToastType } from '@clavisco/alerts';
import { UtilsService } from '../services/utils.service';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationGuard implements CanActivate {
  constructor(private authenticationService: AuthenticationService,
    private alertService: AlertsService,
    private utilsService: UtilsService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      let sessionInformation: ISession | null = Repository.Behavior.GetStorageObject<ISession>(StorageKeys.SESSION);

      if(!sessionInformation)
      {
        this.authenticationService.LogOut();
        
        this.alertService.Toast({message: "Your session is not active. Please log in again.", type: CLToastType.INFO});

        return false;
      }

      if(this.utilsService.DateToMilliseconds(sessionInformation.expires) < this.utilsService.DateToMilliseconds(new Date()))
      {
        this.authenticationService.LogOut();
        
        this.alertService.Toast({message: "Your session has expired. Please log in again.", type: CLToastType.INFO});

        return false;
      }

    return true;
  }
  
}
